import React, { memo } from "react";
import { Center, Box, Flex, Text } from "@chakra-ui/react";
export default memo(function HowComponent() {
   return (
      <Flex
         flexDir={"column"}
         alignItems={"center"}
         py={"120px"}
         mt={"120px"}
         w={"1280px"}
         mx={'auto'}
         bg={"#EFF7FA"}
         borderRadius={"20px"}>
         <Center>
            <Text fontSize={34} color={"green.500"} mr={"17px"}>
               How
            </Text>
            <Text fontSize={34}>does AlohaBots go beyond your expectations?</Text>
         </Center>
         <Flex flexDir={"column"} mt={"69px"} w={"820px"}>
            <Flex flexDir={"row"}>
               <Flex alignItems={"center"} flexDir={"column"} userSelect='none'>
                  <Text fontSize={24} w={'62px'} h={'62px'} bg={'white'} borderRadius={'full'}  lineHeight={'62px'} textAlign='center'  boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'} fontFamily={'Arial-BoldMT'} color={"green.500"}>
                     01
                  </Text>
                  <Box w={"1px"} flex={'1'} bg="#B6ECDB" />
               </Flex>
               <Text fontSize={20} color={"#333"} ml={"47px"} mb={"40px"}>
                  Existing sales bots in the market are slow when capturing sales with missing data from time to time.
                  AlohaBots surpasses them by providing the most timely and comprehensive transaction data.
               </Text>
            </Flex>
            <Flex flexDir={"row"}>
               <Flex alignItems={"center"} flexDir={"column"} userSelect='none'>
                  <Text fontSize={24} w={'62px'} h={'62px'} bg={'white'} borderRadius={'full'}  lineHeight={'62px'} textAlign='center'  boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'} fontFamily={'Arial-BoldMT'} color={"green.500"}>
                     02
                  </Text>
                  <Box w={"1px"} flex={1} bg="#B6ECDB" />
               </Flex>
               <Text fontSize={20} color={"#333"} ml={"47px"} mb={"40px"}>
                  Being fast and trustworthy are not enough, AlohaBots also offers extensive intellectualisations and
                  customisations.{" "}
               </Text>
            </Flex>
            <Flex flexDir={"row"} alignItems='center'>
               <Flex alignItems={"center"} flexDir={"column"} userSelect='none'>
                  <Text fontSize={24} w={'62px'} h={'62px'} borderRadius={'full'}  bg={'white'} lineHeight={'62px'} textAlign='center'  boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'} fontFamily={'Arial-BoldMT'} color={"green.500"}>
                     03
                  </Text>
               </Flex>
               <Text fontSize={20} color={"#333"} ml={"47px"}>
                  AlohaBots is not only easy to use, it also goes above-and-beyond expectations.
               </Text>
            </Flex>
         </Flex>
      </Flex>
   );
});
